// extracted by mini-css-extract-plugin
export default {"deleteAlert":"frVRFThOLLC5QJTnRZ1L","content":"o5CcLO2v0oobbhbGiUNr","info":"aFPOCYV9NmSdZTTGqjvk","input":"SccAjzc7wPjIHM9Mucxl"};